import React from "react"
import { Switch, HashRouter as Router, Route } from "react-router-dom"
import Home from "./routes/Home"

export default () => {
  return (
    <Router>
      <Switch>
        <Route
          exact
          path={["/", "/:model", "/:model/:subModel"]}
          component={Home}
        />
      </Switch>
    </Router>
  )
}
